module.exports = __webpack_public_path__ + "img/4.2cf5e5f6.png";